/**
 * Banner API Service
 * Service for fetching banner images from API
 */

const BANNER_API_URL = 'https://api.jackopot.com/api/banners/getAllImagesBinary';

/**
 * Fetch all banner images from API
 * @returns {Promise<Array>} Array of banner objects with id, type, and base64 image
 */
export const fetchBanners = async () => {
  try {
    const response = await fetch(BANNER_API_URL);
    
    if (!response.ok) {
      throw new Error(`HTTP ${response.status}`);
    }
    
    const data = await response.json();
    
    if (data.status === 'success' && data.images) {
      // Process banners and convert to base64 data URLs
      return data.images.map((img) => ({
        id: img.id,
        type: img.type || 'banner',
        image: `data:image/png;base64,${img.base64}`,
      }));
    }
    
    return [];
  } catch (error) {
    console.error('Error fetching banners:', error);
    return [];
  }
};
